import React, { useContext, useState } from "react";
import { API, list_repas } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, FormControlLabel, FormGroup, Checkbox, Stack, TextField, Typography, MenuItem } from "@mui/material";
import moment from "moment";

export default function SessionForm(props) {
    const {updateConnect} = useContext(Context)
    const [load, setload] = useState(false)
    const [label, setLabel] = useState(props.session?.label??'')
    const [date, setDate] = useState(props.session?.date?moment.utc(props.session?.date).format('yyyy-MM-DD'):'')
    const [active, setActive] = useState(props.session?.active??true)
    const [isRepas, setIsRepas] = useState(props.session?.isRepas??false)
    const [msg, setMsg] = useState()

    async function handleSubmit(event) {
        event.preventDefault()
        setload(true); setMsg('')
        fetch(API.concat(props.edit?`/Session/by/${JSON.stringify({_id: props.session?._id})}`:'/session'), {method:props.edit?'PATCH':'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({
                label, date, active, isRepas
            })
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    props.add(json); props.close()
                    setload(false)
                }else {
                    const text = await response.text()
                    setMsg(text)
                    setload(false)
                }
            }
        })
    }

    return(
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit?'Modifier':'Créer'} une session de Scan</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                {isRepas?<TextField select required label="Repas" value={label} onChange={(event)=> setLabel(event.target.value)}
                    slotProps={{ inputLabel: { shrink: true } }} sx={{minWidth:'200px', width:'70%', alignSelf:'center'}}>
                    {list_repas.map((repas, index)=><MenuItem key={index} value={repas}>{repas}</MenuItem>)}
                </TextField>
                :<Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Libellé" autoFocus sx={{minWidth:'200px'}} value={label} onChange={(event)=> setLabel(event.target.value)}
                    error={/^\s*$/.test(label)&&label!==""} helperText={/^\s*$/.test(label)&&label!=="" && "ne doit pas contenir que des espaces" }/>
                    <TextField fullWidth label="Date" type="date" sx={{minWidth:'200px'}} slotProps={{ inputLabel: { shrink: true } }} 
                    value={date} onChange={(event)=> setDate(event.target.value)}/>
                </Stack>}
                <FormGroup row spacing={2}>
                    <FormControlLabel control={<Checkbox checked={active} onChange={e=>setActive(old=>!old)}/>} label="Active" />
                    <FormControlLabel control={<Checkbox checked={isRepas} onChange={e=>{setLabel(''); setIsRepas(old=>!old)}}/>} label="Repas" />
                </FormGroup>
            </Stack>

            <Button variant="contained" type="submit" sx={{marginTop:'20px', borderRadius:0, paddingBlock:1.5}}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}